import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('jira-issue-view-chin-m2-performance', 'isIssueSearchAPIEnabled', false);
	},
};
